import '@ionic/core';
import { Component, Event, EventEmitter, Prop, h, State, Watch } from '@stencil/core';

import { retrieveSelectorData } from '../../utils/tools';

@Component({
    tag: 'selector-partner-type',
    styleUrl: 'selector-partner-type.css',
    shadow: true
})

export class PartnerTypeSelector {
    // The cohort from which partners will be selected.
    @Prop() cohortId = 0;

    // The list of selected partners.
    @Prop() partnerSelections: Array<string>; 

    // The number of partners selected.
    @State() selectedCount: number; 

    // A flag denoting whether the partners list is loaded.
    @State() partnersLoaded: boolean = false; 

    // A flag denoting whether this is the first time the component has loaded.
    private firstRun: boolean = true; 

    // The base URL for data.
    private baseUrl: string = `https://api.probono.savvysuit.com/v2/cohort/${this.cohortId}`; 

    // The list of partners the user can select from.
    private partnersList: Array<any> = [];

    @Watch('partnerSelections') 
    watchHandler(newValue: Array<string>) {
        // console.log(`Updated partners property in selector-partner-type component, newValue: ${newValue}, oldValue: ${oldValue}`);
        // this.partnerSelections = newValue;
        this.selectedCount = newValue.length;
    }

    @Event() partnersSelectionCompleted: EventEmitter;

    private updatePartnersSelected = (e: any) => {
        try {
            this.selectedCount = e.detail.value.length;
        } catch (error) {
            this.selectedCount = 0;
        }
        
        this.partnersSelectionCompleted.emit(e.detail.value);
    }

    private processPartners = (rawPartners: Array<any>) => {
        if(rawPartners.length > 0) {
            const formattedPartnerList = [];

            rawPartners.forEach(partner => {
                formattedPartnerList.push({
                    value: partner.partner_sitename,
                    label: partner.partner_name,
                    disabled: false
                });
            });

            this.partnersLoaded = true;

            this.partnersList = formattedPartnerList;

        }

        console.log(`Updated list of Partners for cohort ${this.cohortId}.`);

        this.render();
    }

    private loadPartners = async () => {
        console.log(`Requesting list of current Partners for cohort ${this.cohortId}.`);

        const that = this;

        try {
            const response = await retrieveSelectorData(this.baseUrl.concat('/partners'))
            console.log(`Successfully retrieved partners list for cohort ${that.cohortId}.`);
            that.processPartners(response.data);
        } catch (error) {
            console.log('I was unable to update the case list (timeout?).')

            that.processPartners([]);
        }

        /* axios.get(this.baseUrl.concat('/partners'), {timeout: 1000})
            .then(function (response) {
                console.log(`Successfully retrieved partners list for cohort ${that.cohortId}.`);
                that.processPartners(response.data);
            })
            .catch(function () {
                console.log('I was unable to update the case list (timeout?).')

                that.processPartners([]);
            }) */
    }

    componentWillLoad() {
        if(this.firstRun) {
            try {
                this.selectedCount = this.partnerSelections.length;
            } catch (error) {
                this.selectedCount = 0;
            }
    
            this.firstRun = false;
        }

        const styleBodyText = ".SSPBPartnerTypeSelectorAlert { --max-width: unset !important; --width: 60% !important; } .alert-checkbox-button-disabled .alert-checkbox-icon { display: none; } .alert-checkbox-button-disabled .alert-checkbox-label { padding-left: 25px; }";
        const alertStyleText = document.createTextNode(styleBodyText);
        const alertStyle: any = document.createElement('style');

        alertStyle.type = 'text/css';
        alertStyle.appendChild(alertStyleText)

        document.getElementsByTagName("head")[0].appendChild(alertStyle);

        this.loadPartners();
    }

    selectClicked() {
        /* const alertElement = document.querySelector('ion-alert.SSPBPartnerTypeSelectorAlert');
        alertElement.setAttribute("style", "position: fixed; height: 100vh;");
        console.log('Updated ion-alert position for partner-type select'); */
        return;
    }

    render() {
        if(this.partnersLoaded) {
            return ( 
                <div id="PartnerTypeSelectorStage">
                    <ion-item>
                        <ion-select label="Partners" onIonBlur={this.selectClicked}
                          interfaceOptions={{cssClass: 'SSPBPartnerTypeSelectorAlert'}} id="SSPBPartnerTypeSelector"
                          value={this.partnerSelections} multiple={true} onIonChange={this.updatePartnersSelected}
                          selectedText={`${this.selectedCount} selected`}>
                            {this.partnersList.map(type => {
                                return (
                                    <ion-select-option value={type.value} disabled={type.disabled}>{type.label}</ion-select-option>
                                );
                            })}
                        </ion-select>
                    </ion-item>
                </div>
            );
        }
    }
}
